import t, { Component as e } from "react";
import o from "../../../../node_modules/classnames/index.js";
import "../../../utils/DomHandler.js";
import s from "../../../utils/ObjectUtils.js";
function r(t) {
  if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function i(t, e) {
  for (var o = 0; o < e.length; o++) {
    var s = e[o];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
  }
}
function n(t, e, o) {
  return e in t ? Object.defineProperty(t, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = o, t;
}
function l(t) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function a(t) {
  for (var e = 1; e < arguments.length; e++) {
    var o = null != arguments[e] ? arguments[e] : {},
      s = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (s = s.concat(Object.getOwnPropertySymbols(o).filter(function (t) {
      return Object.getOwnPropertyDescriptor(o, t).enumerable;
    }))), s.forEach(function (e) {
      n(t, e, o[e]);
    });
  }
  return t;
}
function c(t, e) {
  return (c = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
var p = function (e) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && c(t, e);
  }(d, e);
  var p,
    h,
    u,
    f = (p = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }(), function () {
      var t,
        e,
        o = l(d);
      if (p) {
        var s = l(this).constructor;
        e = Reflect.construct(o, arguments, s);
      } else e = o.apply(this, arguments);
      return (t = e) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : r(this);
    });
  function d() {
    var t;
    return !function (t, e) {
      if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, d), t = f.apply(this, arguments), n(r(t), "el", void 0), n(r(t), "content", void 0), n(r(t), "spacer", void 0), n(r(t), "sticky", void 0), n(r(t), "lastScrollPos", t.isBoth() ? {
      top: 0,
      left: 0
    } : 0), n(r(t), "scrollTimeout", void 0), n(r(t), "state", {
      first: t.isBoth() ? {
        rows: 0,
        cols: 0
      } : 0,
      last: t.isBoth() ? {
        rows: 0,
        cols: 0
      } : 0,
      numItemsInViewport: t.isBoth() ? {
        rows: 0,
        cols: 0
      } : 0,
      numToleratedItems: t.props.numToleratedItems,
      loading: t.props.loading,
      loaderArr: []
    }), n(r(t), "scrollTo", function (e) {
      t.el && t.el.scrollTo(e);
    }), n(r(t), "scrollToIndex", function (e) {
      var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "auto",
        s = t.isBoth(),
        r = t.isHorizontal(),
        i = t.state.first,
        n = t.state.numToleratedItems,
        l = t.props.itemSize,
        a = t.getContentPosition(),
        c = function c() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            e = arguments.length > 1 ? arguments[1] : void 0;
          return t <= e ? 0 : t;
        },
        p = function p(t, e, o) {
          return t * e + o;
        },
        h = function h() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          return t.scrollTo({
            left: e,
            top: s,
            behavior: o
          });
        };
      if (s) {
        var u = {
          rows: c(e[0], n[0]),
          cols: c(e[1], n[1])
        };
        (u.rows !== i.rows || u.cols !== i.cols) && (h(p(u.cols, l[1], a.left), p(u.rows, l[0], a.top)), t.setState({
          first: u
        }));
      } else {
        var f = c(e, n);
        f !== i && (r ? h(p(f, l, a.left), 0) : h(0, p(f, l, a.top)), t.setState({
          first: f
        }));
      }
    }), n(r(t), "onScroll", function (e) {
      t.props.onScroll && t.props.onScroll(e), t.props.delay ? (e.persist(), t.scrollTimeout && clearTimeout(t.scrollTimeout), !t.state.loading && t.props.showLoader && t.onScrollPositionChange(e).isRangeChanged && t.setState({
        loading: !0
      }), t.scrollTimeout = setTimeout(function () {
        t.onScrollChange(e), t.state.loading && t.props.showLoader && !t.props.lazy && t.setState({
          loading: !1
        });
      }, t.props.delay)) : t.onScrollChange(e);
    }), t;
  }
  return h = [{
    key: "isBoth",
    value: function value() {
      return "both" === this.props.orientation;
    }
  }, {
    key: "scrollInView",
    value: function value(t, e) {
      var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "auto",
        s = this;
      if (e) {
        var r = this.isBoth(),
          i = this.isHorizontal(),
          n = this.getRenderedRange(),
          l = n.first,
          a = n.viewport,
          c = this.props.itemSize,
          p = function p() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            return s.scrollTo({
              left: t,
              top: e,
              behavior: o
            });
          };
        if ("to-start" === e) {
          if (r) a.first.rows - l.rows > t[0] ? p(a.first.cols * c, (a.first.rows - 1) * c) : a.first.cols - l.cols > t[1] && p((a.first.cols - 1) * c, a.first.rows * c);else if (a.first - l > t) {
            var h = (a.first - 1) * c;
            i ? p(h, 0) : p(0, h);
          }
        } else if ("to-end" === e) {
          if (r) a.last.rows - l.rows <= t[0] + 1 ? p(a.first.cols * c, (a.first.rows + 1) * c) : a.last.cols - l.cols <= t[1] + 1 && p((a.first.cols + 1) * c, a.first.rows * c);else if (a.last - l <= t + 1) {
            var u = (a.first + 1) * c;
            i ? p(u, 0) : p(0, u);
          }
        }
      } else this.scrollToIndex(t, o);
    }
  }, {
    key: "getRows",
    value: function value() {
      return this.state.loading ? this.props.loaderDisabled ? this.state.loaderArr : [] : this.loadedItems();
    }
  }, {
    key: "getColumns",
    value: function value() {
      if (this.props.columns) {
        var t = this.isBoth(),
          e = this.isHorizontal();
        if (t || e) return this.state.loading && this.props.loaderDisabled ? t ? this.state.loaderArr[0] : this.state.loaderArr : this.props.columns.slice(t ? this.state.first.cols : this.state.first, t ? this.state.last.cols : this.state.last);
      }
      return this.props.columns;
    }
  }, {
    key: "getRenderedRange",
    value: function value() {
      var t,
        e = this.isBoth(),
        o = this.isHorizontal(),
        s = this.state,
        r = s.first,
        i = s.last,
        n = s.numItemsInViewport,
        l = this.props.itemSize,
        a = function a(t, e) {
          return Math.floor(t / (e || t));
        },
        c = r;
      if (this.el) {
        var p = this.el.scrollTop,
          h = this.el.scrollLeft;
        t = e ? {
          rows: (c = {
            rows: a(p, l[0]),
            cols: a(h, l[1])
          }).rows + n.rows,
          cols: c.cols + n.cols
        } : (c = a(o ? h : p, l)) + n;
      }
      return {
        first: r,
        last: i,
        viewport: {
          first: c,
          last: t
        }
      };
    }
  }, {
    key: "isVertical",
    value: function value() {
      return "vertical" === this.props.orientation;
    }
  }, {
    key: "isHorizontal",
    value: function value() {
      return "horizontal" === this.props.orientation;
    }
  }, {
    key: "calculateOptions",
    value: function value() {
      var t = this,
        e = this.isBoth(),
        o = this.isHorizontal(),
        s = this.state.first,
        r = this.props.itemSize,
        i = this.getContentPosition(),
        n = this.el ? this.el.offsetWidth - i.left : 0,
        l = this.el ? this.el.offsetHeight - i.top : 0,
        a = function a(t, e) {
          return Math.ceil(t / (e || t));
        },
        c = function c(t) {
          return Math.ceil(t / 2);
        },
        p = e ? {
          rows: a(l, r[0]),
          cols: a(n, r[1])
        } : a(o ? n : l, r),
        h = this.state.numToleratedItems || (e ? [c(p.rows), c(p.cols)] : c(p)),
        u = function u(e, o, s, r) {
          return t.getLast(e + o + (e < s ? 2 : 3) * s, r);
        },
        f = e ? {
          rows: u(s.rows, p.rows, h[0]),
          cols: u(s.cols, p.cols, h[1], !0)
        } : u(s, p, h),
        d = {
          numItemsInViewport: p,
          last: f,
          numToleratedItems: h
        };
      this.props.showLoader && (d.loaderArr = e ? Array.from({
        length: p.rows
      }).map(function () {
        return Array.from({
          length: p.cols
        });
      }) : Array.from({
        length: p
      })), this.setState(d, function () {
        if (t.props.lazy) {
          var e = t.getSafeLastIndex(t.state.last);
          t.props.onLazyLoad && t.props.onLazyLoad({
            first: t.state.first,
            last: e
          });
        }
      });
    }
  }, {
    key: "getLast",
    value: function value() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        e = arguments.length > 1 ? arguments[1] : void 0;
      return this.props.items ? Math.min(e ? (this.props.columns || this.props.items[0]).length : this.props.items.length, t) : 0;
    }
  }, {
    key: "getContentPosition",
    value: function value() {
      if (this.content) {
        var t,
          e,
          o = getComputedStyle(this.content);
        t = a({}, o), e = e = {
          paddingLeft: (parseInt(o.paddingLeft, 10) || 0).toString(),
          paddingRight: (parseInt(o.paddingRight, 10) || 0).toString(),
          left: (parseInt(o.left, 10) || 0).toString(),
          right: (parseInt(o.right, 10) || 0).toString(),
          paddingTop: (parseInt(o.paddingTop, 10) || 0).toString(),
          paddingBottom: (parseInt(o.paddingBottom, 10) || 0).toString(),
          top: (parseInt(o.top, 10) || 0).toString(),
          bottom: (parseInt(o.bottom, 10) || 0).toString()
        }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : function (t, e) {
          var o = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(t);
            o.push.apply(o, s);
          }
          return o;
        }(Object(e)).forEach(function (o) {
          Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(e, o));
        });
        var s = (o = t).paddingLeft + Math.max(parseInt(o.left), 0),
          r = o.paddingRight + Math.max(parseInt(o.right), 0),
          i = o.paddingTop + Math.max(parseInt(o.top), 0),
          n = o.paddingBottom + Math.max(parseInt(o.bottom), 0);
        return {
          left: s,
          right: r,
          top: i,
          bottom: n,
          x: s + r,
          y: i + n
        };
      }
      return {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        x: 0,
        y: 0
      };
    }
  }, {
    key: "setSize",
    value: function value() {
      var t = this;
      if (this.el) {
        var e = this.isBoth(),
          o = this.isHorizontal(),
          s = this.el.parentElement,
          r = this.props.scrollWidth || "".concat(this.el.offsetWidth || s.offsetWidth, "px"),
          i = this.props.scrollHeight || "".concat(this.el.offsetHeight || s.offsetHeight, "px"),
          n = function n(e, o) {
            return t.el.style[e] = o;
          };
        e || o ? (n("height", i), n("width", r)) : n("height", i);
      }
    }
  }, {
    key: "setSpacerSize",
    value: function value() {
      var t = this,
        e = this.props.items;
      if (this.spacer && e) {
        var o = this.isBoth(),
          s = this.isHorizontal(),
          r = this.props.itemSize,
          i = "number" == typeof r ? r : r[0],
          n = "number" == typeof r ? r : r[1],
          l = this.getContentPosition(),
          a = function a(e, o) {
            var s = (e || []).length * o,
              r = t.props.getSpacerHeight ? t.props.getSpacerHeight(s) : s;
            t.spacer.style.height = "max(100%, ".concat(r, "px)");
          },
          c = function c(e, o, s) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              i = (o || []).length * s + r;
            t.spacer.style.width = i + "px";
          };
        o ? (a(e, i), c(this.props.columns || e[1], n, l.x)) : s ? c(this.props.columns || e, n, l.x) : a(e, i);
      }
    }
  }, {
    key: "setContentPosition",
    value: function value(t) {
      var e = this;
      if (this.content) {
        var o = this.isBoth(),
          s = this.isHorizontal(),
          r = t ? t.first : this.state.first,
          i = this.props.itemSize,
          n = function n(t, e) {
            return t * e;
          },
          l = function l() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            e.sticky && (e.sticky.style.top = "-".concat(o, "px")), e.content.style.transform = "translate3d(".concat(t, "px, ").concat(o, "px, 0)");
          };
        if (o) l(n(r.cols, i[1]), n(r.rows, i[0]));else {
          var a = n(r, i);
          s ? l(a, 0) : l(0, a);
        }
      }
    }
  }, {
    key: "onScrollPositionChange",
    value: function value(t) {
      var e,
        o = this;
      if (0 === this.props.items.length) return {
        first: 0,
        last: 0,
        isRangeChanged: !0
      };
      var s = t.target,
        r = this.isBoth(),
        i = this.isHorizontal(),
        n = this.state,
        l = n.first,
        a = n.last,
        c = n.numItemsInViewport,
        p = n.numToleratedItems,
        h = this.props.itemSize,
        u = this.getContentPosition(),
        f = function f(t, e) {
          return t ? t > e ? t - e : t : 0;
        },
        d = function d(t, e) {
          return Math.floor(t / (e || t));
        },
        m = function m(t, e, o, s, r, i) {
          return t <= r ? r : i ? o - s - r : e + r - 1;
        },
        g = function g(t, e, o, s, r, i, n) {
          return t <= i ? 0 : Math.max(0, n ? t < e ? o : t - i : t > e ? o : t - 2 * i);
        },
        v = function v(t, e, s, r, i, n) {
          var l = e + r + 2 * i;
          return t >= i && (l += i + 1), o.getLast(l, n);
        },
        y = f(s.scrollTop, u.top),
        w = f(s.scrollLeft, u.left),
        S = a,
        b = !1;
      if (r) {
        var I = this.lastScrollPos.top <= y,
          O = this.lastScrollPos.left <= w,
          z = {
            rows: d(y, h[0]),
            cols: d(w, h[1])
          },
          k = {
            rows: m(z.rows, l.rows, a.rows, c.rows, p[0], I),
            cols: m(z.cols, l.cols, a.cols, c.cols, p[1], O)
          };
        e = {
          rows: g(z.rows, k.rows, l.rows, a.rows, c.rows, p[0], I),
          cols: g(z.cols, k.cols, l.cols, a.cols, c.cols, p[1], O)
        }, S = {
          rows: v(z.rows, e.rows, a.rows, c.rows, p[0]),
          cols: v(z.cols, e.cols, a.cols, c.cols, p[1], !0)
        }, b = e.rows !== l.rows && S.rows !== a.rows || e.cols !== l.cols && S.cols !== a.cols, this.lastScrollPos = {
          top: y,
          left: w
        };
      } else {
        var T = i ? w : y,
          P = this.lastScrollPos <= T,
          x = d(T, h),
          L = m(x, l, a, c, p, P);
        e = g(x, L, l, a, c, p, P), S = v(x, e, a, c, p), b = e !== l && S !== a, this.lastScrollPos = T;
      }
      return {
        first: e,
        last: S,
        isRangeChanged: b
      };
    }
  }, {
    key: "getSafeLastIndex",
    value: function value(t) {
      var e,
        o = "number" == typeof t ? t : t.rows;
      return (null === (e = this.props.items) || void 0 === e ? void 0 : e.length) && o >= this.props.items.length ? this.props.items.length - 1 : o;
    }
  }, {
    key: "onScrollChange",
    value: function value(t) {
      var e = this,
        o = this.onScrollPositionChange(t),
        s = o.first,
        r = o.last;
      if (o.isRangeChanged) {
        var i = {
          first: s,
          last: r
        };
        this.setContentPosition(i), this.setState(i, function () {
          if (e.props.onScrollIndexChange && e.props.onScrollIndexChange(i), e.props.lazy) {
            var t = e.getSafeLastIndex(r);
            e.props.onLazyLoad && e.props.onLazyLoad({
              first: s,
              last: t
            });
          }
        });
      }
    }
  }, {
    key: "getOptions",
    value: function value(t) {
      var e = this.state.first,
        o = (this.props.items || []).length,
        s = this.isBoth() ? e.rows + t : e + t;
      return {
        index: s,
        count: o,
        first: 0 === s,
        last: s === o - 1,
        even: s % 2 == 0,
        odd: s % 2 != 0,
        props: this.props
      };
    }
  }, {
    key: "loaderOptions",
    value: function value(t, e) {
      var o = this.state.loaderArr.length;
      return a({
        index: t,
        count: o,
        first: 0 === t,
        last: t === o - 1,
        even: t % 2 == 0,
        odd: t % 2 != 0,
        props: this.props
      }, e);
    }
  }, {
    key: "loadedItems",
    value: function value() {
      var t = this,
        e = this.props.items;
      if (e && !this.state.loading) {
        var o = this.isBoth(),
          s = this.isHorizontal(),
          r = this.state,
          i = r.first,
          n = r.last;
        return o ? e.slice(i.rows, n.rows).map(function (e) {
          return t.props.columns ? e : e.slice(i.cols, n.cols);
        }) : s && this.props.columns ? e : e.slice(i, n);
      }
      return [];
    }
  }, {
    key: "init",
    value: function value() {
      this.setSize(), this.calculateOptions(), this.setSpacerSize();
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.init();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(t) {
      t.itemSize === this.props.itemSize && t.items && t.items.length === (this.props.items || []).length || this.init(), this.props.lazy && t.loading !== this.props.loading && this.state.loading !== this.props.loading && this.setState({
        loading: this.props.loading
      }), t.orientation !== this.props.orientation && (this.lastScrollPos = this.isBoth() ? {
        top: 0,
        left: 0
      } : 0);
    }
  }, {
    key: "renderLoaderItem",
    value: function value(e) {
      var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = this.loaderOptions(e, o),
        i = s.getJSXElement(this.props.loadingTemplate, r);
      return t.createElement(t.Fragment, {
        key: e
      }, i);
    }
  }, {
    key: "renderLoader",
    value: function value() {
      var e = this;
      if (!this.props.loaderDisabled && this.props.showLoader && this.state.loading) {
        var s,
          r = o("virtualscroller__loader", {
            "p-component-overlay": !this.props.loadingTemplate
          });
        if (s = t.createElement("i", {
          className: "virtualscroller--loading-icon pi pi-spinner pi-spin"
        }), this.props.loadingTemplate) {
          var i = this.isBoth(),
            n = this.state.numItemsInViewport;
          s = this.state.loaderArr.map(function (t, o) {
            return e.renderLoaderItem(o, i && {
              numCols: n.cols
            });
          });
        }
        return t.createElement("div", {
          className: r
        }, s);
      }
      return null;
    }
  }, {
    key: "renderSpacer",
    value: function value() {
      var e = this;
      return this.props.showSpacer ? t.createElement("div", {
        ref: function ref(t) {
          return e.spacer = t;
        },
        className: "virtualscroller__spacer"
      }) : null;
    }
  }, {
    key: "renderItem",
    value: function value(e, o) {
      var r = this.getOptions(o),
        i = s.getJSXElement(this.props.itemTemplate, e, r);
      return t.createElement(t.Fragment, {
        key: r.index
      }, i);
    }
  }, {
    key: "renderItems",
    value: function value(t) {
      var e = this;
      return t.map(function (t, o) {
        return e.renderItem(t, o);
      });
    }
  }, {
    key: "renderContent",
    value: function value() {
      var e = this,
        r = this.loadedItems(),
        i = this.renderItems(r),
        n = o("virtualscroller__content", {
          "virtualscroller--loading": this.state.loading
        }),
        l = t.createElement("div", {
          className: n,
          ref: function ref(t) {
            return e.content = t;
          }
        }, i);
      if (this.props.contentTemplate) {
        var a = {
          className: n,
          contentRef: function contentRef(t) {
            return e.content = t;
          },
          spacerRef: function spacerRef(t) {
            return e.spacer = t;
          },
          stickyRef: function stickyRef(t) {
            return e.sticky = t;
          },
          items: r,
          getItemOptions: function getItemOptions(t) {
            return e.getOptions(t);
          },
          children: i,
          element: l,
          props: this.props,
          loading: this.state.loading,
          getLoaderOptions: function getLoaderOptions(t, o) {
            return e.loaderOptions(t, o);
          },
          loadingTemplate: this.props.loadingTemplate,
          itemSize: this.props.itemSize,
          rows: this.getRows(),
          columns: this.getColumns(),
          vertical: this.isVertical(),
          horizontal: this.isHorizontal(),
          both: this.isBoth()
        };
        return s.getJSXElement(this.props.contentTemplate, a);
      }
      return l;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this;
      if (this.props.disabled) {
        var r = s.getJSXElement(this.props.contentTemplate, {
          items: this.props.items,
          rows: this.props.items,
          columns: this.props.columns
        });
        return t.createElement(t.Fragment, null, this.props.children, r);
      }
      var i = o("kaseya-ui-virtualscroller", {
          "virtualscroller--both-scroll": this.isBoth(),
          "virtualscroller--horizontal-scroll": this.isHorizontal()
        }, this.props.className),
        n = this.renderLoader(),
        l = this.renderContent(),
        a = this.renderSpacer();
      return t.createElement("div", {
        ref: function ref(t) {
          return e.el = t;
        },
        className: i,
        tabIndex: 0,
        style: this.props.style,
        onScroll: this.onScroll
      }, l, a, n);
    }
  }], i(d.prototype, h), u && i(d, u), d;
}(e);
n(p, "defaultProps", {
  id: null,
  style: null,
  className: null,
  items: null,
  itemSize: 0,
  scrollHeight: null,
  scrollWidth: null,
  orientation: "vertical",
  numToleratedItems: null,
  delay: 0,
  lazy: !1,
  disabled: !1,
  loaderDisabled: !1,
  columns: null,
  loading: !1,
  showSpacer: !0,
  showLoader: !1,
  loadingTemplate: null,
  itemTemplate: null,
  contentTemplate: null,
  onScroll: null,
  onScrollIndexChange: null,
  onLazyLoad: null,
  getSpacerHeight: null
});
export { p as VirtualScroller };